exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test {\n  margin: 15rem auto;\n  color: white;\n  font-weight: 900;\n  text-align: center;\n}\n.faceSketch{\n    width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/home-banner/home-banner.component.css
// module id = ../../../../../src/app/home-banner/home-banner.component.css
// module chunks = main